// extracted by mini-css-extract-plugin
export default {"overlay":"Yz-z","bodyOpen":"Zz-z","content":"_z-z","header":"aA-z","close":"bA-z","closeNoHeading":"cA-z"};